import { IInitialisable } from "src/scripts/interfaces/IInitialisable";
import { SearchWindowType } from "src/scripts/typings/WindowType";
import Cookies from "js-cookie";
import { ICookiePreferences } from "./ICookiePreferences";
import { updateGtagConsentFromPreferences } from "./GtagConsent";
export class GtmSetupConsent implements IInitialisable {
	private windowHelper = window as SearchWindowType;
	private updateGtagConsentFromPreferences = updateGtagConsentFromPreferences;

	// Tested
	Init(): void {
		this.initialiseGtagFunction();
		this.setNonceDataLayerVariable();
		const preferences: ICookiePreferences | string = Cookies.getJSON("cookie-preferences");
		if (!!preferences && typeof preferences === "object" && typeof preferences.performance === "boolean" && typeof preferences.personalisation === "boolean") this.updateGtagConsentFromPreferences(this.windowHelper, preferences.performance, preferences.personalisation);
		this.appendGtmScript();
	}

	// Tested
	private initialiseGtagFunction(): void {
		const windowScope = this.windowHelper;
		windowScope.gtag = function () {
			windowScope.dataLayer = windowScope?.dataLayer || [];
			windowScope.dataLayer.push(arguments);
		};
	}

	// Tested
	private setNonceDataLayerVariable(): void {
		this.windowHelper.dataLayer = this.windowHelper?.dataLayer || [];
		this.windowHelper.dataLayer.push({ Nonce: this.getNonceValue() });
	}

	// Tested
	private getNonceValue(): string | undefined {
		const elementId = "hst-gtm";
		const nonce = document.getElementById(elementId)?.nonce;

		if (nonce) {
			return nonce;
		}
		throw new Error(`Cannot find nonce attribute on element with id: ${elementId}`);
	}

	// Tested
	private appendGtmScript() {
		document.addEventListener("DOMContentLoaded", () => {
			const script = document.createElement("script");

			script.nonce = this.getNonceValue();

			script.textContent = `(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({
				"gtm.start": new Date().getTime(),
				event: "gtm.js",
			});
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != "dataLayer" ? "&l=" + l : "";
			j.async = true;
			j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, "script", "dataLayer", "GTM-NTXB9BS")`;
			document.body.appendChild(script);
		});
	}
}
